import Vue from 'vue'
import router from './router.js'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import ptPT from "vee-validate/dist/locale/pt_PT.json";
import * as rules from "vee-validate/dist/rules";
import VueAuth from '@websanova/vue-auth'
import VueAuthUtils from '@websanova/vue-auth/src/lib/utils.js'
import Bearer from './auth/bearer.js' 

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.css'



// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("pt_PT", ptPT);

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

import { configure } from 'vee-validate';

configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
    dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
    // ...
  }
})

Vue.config.productionTip = false
// Vue.use(VueRouter)
Vue.router = router
Vue.use(BootstrapVue)
let apiRoot = 'https://api.camtil.pt'
// let apiRoot = 'http://api.camtil.test'
Vue.prototype.APIURL = apiRoot
axios.defaults.baseURL = apiRoot

Vue.use(VueAxios, axios)

Vue.use(VueAuth, {
  auth: Bearer,
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  authRedirect: {
    path: '/login'
  },
  fetchData: {
    url: 'users/me'
  },
  refreshData: {
    url: 'auth/refresh'
  },
  // rolesVar: 'permissions'
  check: function (role) {
    if (this.watch.authenticated === true) {
      if (role) {
        if (VueAuthUtils.compare('superuser', this.watch.data['permissions'])) {
          return true
        }
        return VueAuthUtils.compare(role, this.watch.data['roles']) || VueAuthUtils.compare(role, this.watch.data['permissions'])
      }
      return true
    }
    return false
  }
})
Vue.auth.perms = function (perm) {
  return this.options.check.call(this, perm, 'permissions')
}


new Vue({
  render: h => h(App),
  router
}).$mount('#app')
